import React from 'react';

export function ConditionalSplitIcon(): JSX.Element {
  return (
    <svg fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
      <rect fill='#EAF7FA' height='24' rx='6' width='24' />
      <g clipPath='url(#clip0_10119_61865)'>
        <path
          d='M6.77965 15.6214C6.60129 15.4392 6.31212 15.4392 6.13377 15.6214C5.95541 15.8035 5.95541 16.0989 6.13377 16.2811L8.41608 18.6121C8.42015 18.6163 8.42429 18.6204 8.4285 18.6244C8.51012 18.7023 8.61973 18.75 8.74024 18.75L8.74161 18.75C8.80255 18.7498 8.86067 18.7374 8.91377 18.7151C8.96812 18.6924 9.01905 18.6585 9.06318 18.6134L11.3467 16.2811C11.5251 16.0989 11.5251 15.8035 11.3467 15.6214C11.1684 15.4392 10.8792 15.4392 10.7008 15.6214L9.19695 17.1574L9.19695 6.54421C9.19695 6.54421 9.19695 6 8.74024 6C8.28353 6 8.28353 6.54421 8.28353 6.54421L8.28353 17.1574L6.77965 15.6214Z'
          fill='#21A3C5'
        />
        <path
          d='M17.9704 15.6214C18.1487 15.4392 18.4379 15.4392 18.6162 15.6214C18.7946 15.8035 18.7946 16.0989 18.6162 16.2811L16.3339 18.6121C16.3299 18.6163 16.3257 18.6204 16.3215 18.6244C16.2399 18.7023 16.1303 18.75 16.0098 18.75L16.0084 18.75C15.9475 18.7498 15.8893 18.7374 15.8362 18.7151C15.7819 18.6924 15.731 18.6585 15.6868 18.6134L13.4033 16.2811C13.2249 16.0989 13.2249 15.8035 13.4033 15.6214C13.5816 15.4392 13.8708 15.4392 14.0492 15.6214L15.5531 17.1574L15.5531 11.9863C15.5531 11.8626 15.5049 11.7439 15.4193 11.6564C15.3336 11.569 15.2175 11.5198 15.0963 11.5198L8.39798 11.5198L8.39798 10.5869L15.0963 10.5869C15.4597 10.5869 15.8082 10.7343 16.0652 10.9968C16.3221 11.2592 16.4665 11.6151 16.4665 11.9863L16.4665 17.1574L17.9704 15.6214Z'
          fill='#21A3C5'
        />
      </g>
      <defs>
        <clipPath id='clip0_10119_61865'>
          <rect fill='white' height='12.75' transform='translate(6 6)' width='12.75' />
        </clipPath>
      </defs>
    </svg>
  );
}
